export * from './medicalDocument.slice';
